/**
 * Waitlist route - Shown to unapproved users
 */

import { createFileRoute } from '@tanstack/react-router';
import { WaitlistPage } from '../components/Auth/WaitlistPage';

export const Route = createFileRoute('/waitlist')({
  component: WaitlistPage,
});
